import { createAction } from '@reduxjs/toolkit';
import { getFailurePayload } from 'modules/utils';

import type { EnumMediaType, Media } from 'types/Medias';
import * as actionTypes from './actionTypes';

export const readMessages = createAction(actionTypes.READ_MESSAGES, () => ({
  payload: {
    request: {
      method: 'PATCH',
    },
  },
}));

export const readMessagesSuccess = createAction(actionTypes.READ_MESSAGES_SUCCESS, (intervention) => ({
  payload: intervention,
}));

export const readMessagesFailure = createAction(actionTypes.READ_MESSAGES_FAILURE, getFailurePayload);

const toMediaPayload = (media: Pick<Media<EnumMediaType>, 'filename' | 'name' | 'type'> & { uploadId: string }) => ({
  filename: media.filename ?? media.name,
  type: media.type,
  uploadId: media.uploadId,
});

export const sendMessage = createAction(
  actionTypes.SEND_MESSAGE,
  ({ message, medias }: { message: string; medias?: Array<Parameters<typeof toMediaPayload>[0]> }) => ({
    payload: {
      request: {
        method: 'POST',
        data: {
          message,
          medias: medias && medias.length > 0 ? medias.map(toMediaPayload) : undefined,
        },
      },
    },
  })
);

export const sendMessageSuccess = createAction(
  actionTypes.SEND_MESSAGE_SUCCESS,
  (intervention, meta: Record<string, unknown> = {}) => ({
    payload: intervention,
    meta,
  })
);

export const sendMessageFailure = createAction(actionTypes.SEND_MESSAGE_FAILURE, getFailurePayload);

export const fetchMessagesSuccess = createAction(actionTypes.FETCH_MESSAGES_SUCCESS);

export const fetchMessagesFailure = createAction(actionTypes.FETCH_MESSAGES_FAILURE, getFailurePayload);

export const fetchNextMessages = createAction(actionTypes.FETCH_NEXT_MESSAGES);

export const fetchNextMessagesSuccess = createAction(actionTypes.FETCH_NEXT_MESSAGES_SUCCESS);

export const fetchNextMessagesFailure = createAction(actionTypes.FETCH_NEXT_MESSAGES_FAILURE, getFailurePayload);
